import Vue from 'vue';
import MTD from '@ss/mtd-vue';

Vue.use(MTD);
